import React, { Component } from 'react';
import AutenthicationService from './services/authservice.js';
import { Redirect, Route } from 'react-router-dom';

export class AuthRouter extends Component {
  render() {
    if (AutenthicationService.isLogged()) {
      console.log(
        'OUTPUT: AuthRouter -> render -> AutenthicationService.isLogged'
      );
      return <Route {...this.props}></Route>;
    } else {
      return <Redirect to='/login/:call' />;
    }
  }
}

export default AuthRouter;
